import React, {useEffect, useState} from "react";
import "./PayPage.sass";
import TeacherGrid from "../../_components/teacher/TeacherGrid";
import {Paper, TableContainer} from "@mui/material";
import Table from "@mui/material/Table";
import {FAILED, IDLE, LOADING, SUCCESS} from "../../common/statuses";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {StyledTableCell, StyledTableRow} from "../../_components/TableComponents";
import TableBody from "@mui/material/TableBody";
import moment from "moment/moment";
import {useDispatch, useSelector} from "react-redux";
import {confirmPayment, getPaymentsForTeacher} from "../../_actions/receipt/receiptService";
import Spinner from "../common/anonymous/Spinner";
import ButtonComponent from "../../_components/common/buttons/ButtonComponent";
import DialogComponent from "../../_components/common/dialog/DialogComponent";
import {ADDRESS} from "../../_api/client";
import TextFieldEdit from "../../_components/common/fields/TextFieldEdit";
import {useSnackbar} from "notistack";
import {clearReceiptState} from "../../_actions/receipt/receipReducer";

export default function PayPage() {
    const [description, setDescription] = useState();
    const [paymentConfirmation, setPaymentConfirmation] = useState();
    const [amount, setAmount] = useState("0");

    const {data, status} = useSelector(state => state.payments.getPayments);
    const {message: confirmMessage, status: confirmStatus} = useSelector(state => state.payments.confirmPayment);

    const dispatch = useDispatch();
    const {enqueueSnackbar} = useSnackbar()

    useEffect(() => {
        if (status === IDLE) {
            dispatch(getPaymentsForTeacher());
        }
    }, [status, dispatch])
    useEffect(() => {
        if (confirmStatus === SUCCESS) {
            enqueueSnackbar(confirmMessage, {variant: "success"})
            setPaymentConfirmation(null)
            dispatch(clearReceiptState())
        }
        if (confirmStatus === FAILED) {
            enqueueSnackbar("Произошла ошибка", {variant: "error"})
        }
    }, [confirmStatus, dispatch])
    useEffect(() => {
        document.title = 'КьюАй - Оплата'
        return () => {
            console.log("pay")
            dispatch(clearReceiptState())
        }
    }, [])

    if (status === IDLE || status === LOADING
        || confirmStatus === LOADING) {
        return <Spinner/>
    }

    const handleConfirmPayment = () => {
        if (paymentConfirmation) {
            const request = {
                ...paymentConfirmation,
                amount: parseFloat(amount) * 100
            }
            dispatch(confirmPayment(request))
        }
    }

    const renderDescriptionDialog = () => {
        if (description) {
            const {id, receipt} = description

            return <DialogComponent title={`Квитанция №${id}`}
                                    buttons={{cancel: "Закрыть"}}
                                    open={!!description}
                                    onClose={() => setDescription(null)}>
                <div className="PayPage-dialog">
                    <img src={`${ADDRESS}/receipt/file/${receipt.id}`} alt={receipt.name}/>
                </div>
            </DialogComponent>
        }
    }

    const renderConfirmationDialog = () => {
        if (paymentConfirmation && !paymentConfirmation.confirmDate) {
            const {id} = paymentConfirmation
            const buttons = {
                accept: "Сохранить",
                cancel: "Закрыть"
            }

            return <DialogComponent title={`Подтверждение квитанции № ${id}`}
                                    buttons={buttons}
                                    open={!!paymentConfirmation}
                                    onAccept={handleConfirmPayment}
                                    onClose={() => setPaymentConfirmation(null)}>
                <div className="PayPage-dialog-edit">
                    <TextFieldEdit type="number"
                                   error={confirmMessage && !!confirmMessage.amount}
                                   helperText={confirmMessage && confirmMessage.amount}
                                   value={amount}
                                   onChange={(e) => setAmount(e.target.value)}
                                   label="Сумма"/>
                </div>
            </DialogComponent>
        }
    }

    return <div className="PayPage-wrapper">
        <TeacherGrid/>
        <div className="PayPage-table-wrapper">
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>Ученик</StyledTableCell>
                            <StyledTableCell>Дата</StyledTableCell>
                            <StyledTableCell>Сумма</StyledTableCell>
                            <StyledTableCell>Статус</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    {data &&
                        <TableBody>
                            {data.map((payment) => {
                                const {id, confirmDate, amount, receipt, student} = payment

                                return (
                                    <StyledTableRow key={`payment-${id}`}
                                                    className={confirmDate && "PayPage-table-disabled-row"}
                                                    onClick={() => setDescription(payment)}>
                                        <StyledTableCell>
                                            {`${student.lastName} ${student.firstName}`}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {moment(receipt.sendDate, "YYYY-MM-DDTHH-mm-SS").calendar()}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {amount ? `${(parseInt(amount) / 100).toFixed(2)} руб.` : "-"}
                                        </StyledTableCell>
                                        <StyledTableCell sx={{width: '10em'}} onClick={e => e.stopPropagation()}>
                                            {confirmDate
                                                ? "Подтверждено"
                                                : <ButtonComponent onClick={() => setPaymentConfirmation(payment)}>
                                                    Обработать
                                                </ButtonComponent>}
                                        </StyledTableCell>
                                    </StyledTableRow>
                                )
                            })}
                        </TableBody>
                    }
                </Table>
            </TableContainer>
        </div>
        {renderDescriptionDialog()}
        {renderConfirmationDialog()}
    </div>
}